import { useState, useEffect } from 'react';

const FONT_SIZES = {
  small: '12px',
  medium: '14px',
  large: '16px',
  xlarge: '18px'
};

const FONT_SIZE_LABELS = {
  small: 'Pequeno',
  medium: 'Médio',
  large: 'Grande',
  xlarge: 'Muito Grande'
};

export const useFontSize = () => {
  const [fontSize, setFontSize] = useState('medium');

  // Carregar tamanho da fonte salvo no localStorage
  useEffect(() => {
    const savedFontSize = localStorage.getItem('userFontSize');
    if (savedFontSize && FONT_SIZES[savedFontSize]) {
      setFontSize(savedFontSize);
      applyFontSize(savedFontSize);
    }
  }, []);

  // Aplicar tamanho da fonte ao documento
  const applyFontSize = (size) => {
    const root = document.documentElement;
    root.style.fontSize = FONT_SIZES[size];
  };

  // Alterar tamanho da fonte
  const changeFontSize = (newSize) => {
    if (FONT_SIZES[newSize]) {
      setFontSize(newSize);
      applyFontSize(newSize);
      localStorage.setItem('userFontSize', newSize);
    }
  };

  // Obter nome de exibição do tamanho
  const getFontSizeLabel = (size) => {
    return FONT_SIZE_LABELS[size] || size;
  };

  // Obter tamanho atual em pixels
  const getCurrentFontSize = () => {
    return FONT_SIZES[fontSize];
  };

  return {
    fontSize,
    changeFontSize,
    getFontSizeLabel,
    getCurrentFontSize,
    FONT_SIZES,
    FONT_SIZE_LABELS
  };
};







